import { create } from 'zustand'

const STORAGE_KEY = 'bonurba_consent'
const CONSENT_VERSION = '2025-02'

function loadConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

function persistConsent(state) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    analytique: state.analytique,
    marketing: state.marketing,
    consentDate: state.consentDate,
    consentVersion: state.consentVersion,
  }))
}

const saved = loadConsent()

const useConsentStore = create((set, get) => ({
  analytique: saved?.analytique ?? null,
  marketing: saved?.marketing ?? null,
  consentDate: saved?.consentDate ?? null,
  consentVersion: saved?.consentVersion ?? null,

  hasConsented: () => {
    const { analytique, marketing } = get()
    return analytique !== null && marketing !== null
  },

  acceptAll: () => {
    const state = {
      analytique: true,
      marketing: true,
      consentDate: new Date().toISOString(),
      consentVersion: CONSENT_VERSION,
    }
    set(state)
    persistConsent(state)
  },

  rejectAll: () => {
    const state = {
      analytique: false,
      marketing: false,
      consentDate: new Date().toISOString(),
      consentVersion: CONSENT_VERSION,
    }
    set(state)
    persistConsent(state)
  },

  savePreferences: ({ analytique, marketing }) => {
    const state = {
      analytique,
      marketing,
      consentDate: new Date().toISOString(),
      consentVersion: CONSENT_VERSION,
    }
    set(state)
    persistConsent(state)
  },

  resetConsent: () => {
    localStorage.removeItem(STORAGE_KEY)
    set({
      analytique: null,
      marketing: null,
      consentDate: null,
      consentVersion: null,
    })
  },
}))

export { useConsentStore, CONSENT_VERSION }
